export const Search = "search";
export const List = "list";